export const URLS = {
  pick_point_map: 'https://map.wb.ru',
  pick_point_map_ge: 'https://map.wildberries.ge',
  auction: 'https://map.wb.ru?auction',
  offer: 'https://point-quality.wb.ru/offer/RU/1.html',
  offerGE: 'https://point-quality.wb.ru/offer/GE/1.html',
  wb_rent: 'https://rent.wildberries.ru/promo/',
  tariffs: 'https://point-quality.wb.ru/offer/RU/3.html',
  ofertaGe: 'https://point-quality.wb.ru/offer/GE/1.html',
  wb_main: 'https://www.wildberries.ru/',
  app_android: 'https://play.google.com/store/apps/details?id=com.wbextdelivery',
  app_ios: 'https://apps.apple.com/us/app/id1528507238',
  wb_point: 'https://point.wb.ru',
  yandex_calendar: 'https://calendar.yandex.ru',
  order_lock_for_new_pwz: 'https://www.wildberries.ru/catalog/211414522/detail.aspx?targetUrl=GP',
  order_lock_for_old_pwz: 'https://www.wildberries.ru/catalog/206479509/detail.aspx?targetUrl=SP',
  wbMarketPrivatePolicy: 'https://www.wildberries.ru/services/politika-obrabotki-personalnyh-dannyh',
  wbMarketPrivatePolicyGe: 'https://www.wildberries.ge/services/privacy-policy',
  signboardArticleWhite: 'https://www.wildberries.ru/catalog/221540808/detail.aspx?targetUrl=EX',
  signboardArticlePurple: 'https://www.wildberries.ru/catalog/221540807/detail.aspx?targetUrl=EX',
  bracketArticle: 'https://www.wildberries.ru/catalog/209248151/detail.aspx?targetUrl=SP',
  wbCourier: 'https://wbk.wb.ru/',
  rutube: 'https://rutube.ru/channel/39669508',
  youtube: 'https://youtube.com/@wb-pvz?si=sdtWbVqfMeyx3YGk',
  learningPortal: 'https://pvz-learning.wb.ru/',
  learningPortalInstructions: 'https://pvz-learning.wb.ru/knowledge/156',
  learningPortalPrintMaterials: 'https://pvz-learning.wb.ru/materials-for-print/30016',
  offerAppendixLink: 'https://point-quality.wb.ru/offer/RU/4.html',
  pvzLk: 'https://pvz-lk.wb.ru/login',
  pvzLkGe: 'https://pvz.wildberries.ge/',

  /** Правила оказания услуг в ПВЗ */
  application: 'https://point-quality.wb.ru/offer/RU/2.html',
  applicationGe: 'https://point-quality.wb.ru/offer/GE/2.html',
  privacyPolicy: 'https://pvz-promo.wb.ru/privacy-policy',
  activePvzController: 'https://www.wildberries.ru/catalog/268735799/detail.aspx?targetUrl=GP',
  newPvzController: 'https://www.wildberries.ru/catalog/268690974/detail.aspx?targetUrl=GP',
}
